let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7G5IV")).then(() => parcelRequire('2MQ7j'));